import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import ConfigsState from '../../types/ConfigsState'

export const configsModule: Module<ConfigsState, RootState> = {
  namespaced: true,
  state: {
    configs: [],
    allowed_countries: null
  },
  getters,
  actions,
  mutations
}
